// Auto generated file, do not manually modify!
// com.hotpads.customeranalytics.api.web.external.portalanalytics.RenterActivityStatsApiHandler

import { getClient } from '../../client';
import { httpApiRequest } from '@zg-rentals/ts-client-http-client';

import type {
  AnalyticsAffordableRentDto,
  AnalyticsAnnualIncomeDto,
  DeprecatedZillowRegionType,
  RenterActivityFilterRegionStatsDto,
  RenterActivityKeywordRegionStatsDto,
  RenterActivityStatsKeywordSearchRequestDto,
  RenterActivityStatsSearchFilterRequestDto,
  RenterDemographicsMonthlyDataDto,
  TopCityMovingStatsDto,
} from '../..';

interface GetRenterAnnualIncomeDistributionParams {
  zillowRegionId: number;
}
interface GetRenterDemographicsMonthlyDataParams {
  zillowRegionId: number;
}
interface GetRenterMonthlyAffordableRentDistributionParams {
  zillowRegionId: number;
}
interface GetTopCityMovingStatsParams {
  zillowRegionId?: string;
  zillowRegionType?: DeprecatedZillowRegionType;
}

export const RenterActivityStatsApiHandler_getFilterStatsByCategory_Path =
  '/api/web/v1/users/renterActivityStats/getFilterStatsByCategory';

export const RenterActivityStatsApiHandler_getFilterStatsByCategory = (
  postData: RenterActivityStatsSearchFilterRequestDto,
  client = getClient(),
) => {
  return httpApiRequest<never, RenterActivityStatsSearchFilterRequestDto, Array<RenterActivityFilterRegionStatsDto>>(
    {
      endpoint: RenterActivityStatsApiHandler_getFilterStatsByCategory_Path,
      method: 'POST',
      contextPath: '/customer-analytics',
      postData: postData,
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const RenterActivityStatsApiHandler_getRenterAnnualIncomeDistribution_Path =
  '/api/web/v1/users/renterActivityStats/getRenterAnnualIncomeDistribution';

export const RenterActivityStatsApiHandler_getRenterAnnualIncomeDistribution = (
  getParams: GetRenterAnnualIncomeDistributionParams,
  client = getClient(),
) => {
  return httpApiRequest<GetRenterAnnualIncomeDistributionParams, never, Array<AnalyticsAnnualIncomeDto>>(
    {
      getParams: getParams,
      endpoint: RenterActivityStatsApiHandler_getRenterAnnualIncomeDistribution_Path,
      method: 'GET',
      contextPath: '/customer-analytics',
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const RenterActivityStatsApiHandler_getRenterDemographicsMonthlyData_Path =
  '/api/web/v1/users/renterActivityStats/getRenterDemographicsMonthlyData';

export const RenterActivityStatsApiHandler_getRenterDemographicsMonthlyData = (
  getParams: GetRenterDemographicsMonthlyDataParams,
  client = getClient(),
) => {
  return httpApiRequest<GetRenterDemographicsMonthlyDataParams, never, RenterDemographicsMonthlyDataDto>(
    {
      getParams: getParams,
      endpoint: RenterActivityStatsApiHandler_getRenterDemographicsMonthlyData_Path,
      method: 'GET',
      contextPath: '/customer-analytics',
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const RenterActivityStatsApiHandler_getRenterMonthlyAffordableRentDistribution_Path =
  '/api/web/v1/users/renterActivityStats/getRenterMonthlyAffordableRentDistribution';

export const RenterActivityStatsApiHandler_getRenterMonthlyAffordableRentDistribution = (
  getParams: GetRenterMonthlyAffordableRentDistributionParams,
  client = getClient(),
) => {
  return httpApiRequest<GetRenterMonthlyAffordableRentDistributionParams, never, Array<AnalyticsAffordableRentDto>>(
    {
      getParams: getParams,
      endpoint: RenterActivityStatsApiHandler_getRenterMonthlyAffordableRentDistribution_Path,
      method: 'GET',
      contextPath: '/customer-analytics',
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const RenterActivityStatsApiHandler_getTopCityMovingStats_Path =
  '/api/web/v1/users/renterActivityStats/getTopCityMovingStats';

export const RenterActivityStatsApiHandler_getTopCityMovingStats = (
  getParams: GetTopCityMovingStatsParams,
  client = getClient(),
) => {
  return httpApiRequest<GetTopCityMovingStatsParams, never, TopCityMovingStatsDto>(
    {
      getParams: getParams,
      endpoint: RenterActivityStatsApiHandler_getTopCityMovingStats_Path,
      method: 'GET',
      contextPath: '/customer-analytics',
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const RenterActivityStatsApiHandler_getTopKeywordSearches_Path =
  '/api/web/v1/users/renterActivityStats/getTopKeywordSearches';

export const RenterActivityStatsApiHandler_getTopKeywordSearches = (
  postData: RenterActivityStatsKeywordSearchRequestDto,
  client = getClient(),
) => {
  return httpApiRequest<never, RenterActivityStatsKeywordSearchRequestDto, Array<RenterActivityKeywordRegionStatsDto>>(
    {
      endpoint: RenterActivityStatsApiHandler_getTopKeywordSearches_Path,
      method: 'POST',
      contextPath: '/customer-analytics',
      postData: postData,
      unwrapApiLayerResponse: true,
    },
    client,
  );
};
